let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("42ilD")).then(() => parcelRequire('heseR'));